export const STUDY_TOPIC = '/topic/study';

export enum StudyMessages {
  LogMessage = 'LogMessage',
  ProgressMessage = 'ProgressMessage',
  /** The P3 realtime envelope — `StudyEvent` in contracts/study/openapi.yaml. */
  StudyEventMessage = 'StudyEventMessage',
}
